import type { UserAccess } from 'shared-types';
import type { ReduxRootState } from 'types';

interface Params {
  includeSingleSignOn: boolean;
  isDemoEnvironment: boolean;
  messages: ReduxRootState['messages'];
}

const getUserAccessOptions = ({
  includeSingleSignOn,
  isDemoEnvironment,
  messages
}: Params) =>
  [
    {
      helpText: messages.settingsAddedUsersOnlyInfo,
      label: messages.settingsAddedUsersOnly,
      value: 'added-only'
    },
    ...(includeSingleSignOn
      ? [
          {
            label: messages.settingsSingleSignOnUsers,
            value: 'sso'
          }
        ]
      : []),
    {
      helpText: messages.settingsRegisteredInfo,
      label: messages.settingsRegistered,
      value: 'registered',
      isDisabled: isDemoEnvironment
    },
    {
      label: messages.settingsRegisteredAndGuests,
      value: 'registered-and-guests',
      isDisabled: isDemoEnvironment
    },
    {
      label: messages.settingsGuestsOnly,
      value: 'guests'
    },
    {
      helpText: messages.settingsRequestAccessInfo,
      label: messages.settingsRequestAccess,
      value: 'request-access',
      isDisabled: isDemoEnvironment
    }
  ] as {
    helpText?: string;
    label: string;
    value: UserAccess;
    isDisabled?: boolean;
  }[];

export default getUserAccessOptions;
